export default __webpack_public_path__ + "static/media/cover_modal_bg_top.7fd9b597.png";